import Kitchen from "./images/konigsstrasse.jpg";
import Hospital from "./images/emergency.jpg";
export const advertContent = [
  {
    id: 1,
    title: "Buy new kitchen pipes",
    content:
      "We at Company XYT are selling kitchen pipes for your plumbing needs",
    image: Kitchen,
  },
  {
    id: 2,
    title: "Are you looking for painters and tilers?",
    content: "We at LLC One are selling offer you painting and tiling services",
    image: Kitchen,
  },
  {
    id: 3,
    title: "Tired of long waits at the hospital?",
    content:
      "Check out Methodist Hospital. Register with any of our doctors to get immediate attention today.",
    image: Hospital,
  },
];
